import type { FilterState } from '@/components/searchFilter/types'

export type ReportTab = 'summary' | 'consequences' | 'questionnaires' | 'effectiveness'
export type ReportGroup = 'department' | 'coordinator' | 'type'
export interface ReportSelection {
  section: string
  bucket: string
  metric: string
}
export interface ReportColumn {
  key: string
  title: string
}
export interface ReportSection {
  key: string
  title: string
  columns: ReportColumn[]
  rows: Array<Record<string, string | number> & { key: string }>
  metrics: string[]
}
export interface ReportRecord {
  id: string
  event_id: string
  number: number
  subject?: string
  answers?: Array<{ question: string; value: string; code: string }>
  [key: string]: unknown
}
export interface AdverseReportResult {
  title: string
  tab: ReportTab
  unit: string
  event_count: number
  applicable_event_count: number
  record_count: number
  related_event_count: number
  questionnaire: string
  questionnaires: Array<{ value: string; label: string }>
  sections: ReportSection[]
  columns: ReportColumn[]
  details: { label: string; count: number; events: number; rows: ReportRecord[] }
  generated_at: string
}

export function reportFilters(state: FilterState, after: string | null, before: string | null) {
  const filters: Record<string, string> = {}
  if (state.search) filters.search = state.search
  if (state.filter.conditions.length) filters.advanced = JSON.stringify(state.filter)
  if (after) filters.created_after = after
  if (before) filters.created_before = before

  return filters
}

export function reportPeriodError(after: string | null, before: string | null): string {
  return after && before && after > before ? 'Начало периода должно быть не позже окончания.' : ''
}
